import Vue from 'vue'
import Vuex from 'vuex'

import d2admin from './modules/d2admin'
import Author from '@/util/author'
import Enum from '@/util/enum'
import util from '@/libs/util.js'
import LocalStorage from "@/libs/util.localStorage.js";

import { GetCurrentUserInfo } from '@/api/systemPrivilege/account'

Vue.use(Vuex)

function resolveCurrentMenuList(menuList) {
  let menuListArray = new Array()
  ;(menuList || []).forEach((menuNode, index) => {
    if (
      menuNode.hasOwnProperty('children') &&
      Array.isArray(menuNode.children) &&
      menuNode.menuTypeCode !==
        Enum.systemPermission.menuManage.menuType.num.button
    ) {
      menuListArray.push({
        title: menuNode.menuName,
        icon: menuNode.icon,
        path: menuNode.url,
        // 递归调用
        children: resolveCurrentMenuList(menuNode.children)
      })
    }
  })
  return menuListArray
}


function resolveRouterMenuList(arr) {
  if (arr.length) {
    for (let i in arr) {
      if (arr[i].children.length) {
        resolveRouterMenuList(arr[i].children)
      } else {
        delete arr[i].children
      }
    }
  }
  return arr
}

export default new Vuex.Store({
  state: {
    systemUser: {
      systemUserId: '',
      realName: '',
      avatar: '',
      jobnumber: '',
      phone: '',
      email: '',
      position: '',
      systemMenuPermissionsRoot: [], // 菜单权限根节点
      systemRoles: []
    } 
  },
  mutations: {
    setSystemUser(state, systemUser) {
      state.systemUser = systemUser
    },
    clearSystemUser(state) {
      state.systemUser = {
        systemUserId: '',
        realName: '',
        avatar: '',
        jobnumber: '',
        phone: '',
        email: '',
        position: '',
        systemMenuPermissionsRoot: [], // 菜单权限根节点
        systemRoles: []
      }
    },
  },
  actions: {
    async getSystemUser({ state, commit, dispatch, rootState }) {
      function setData(systemUser) {
          var menuList = systemUser.systemMenuPermissionsRoot.children || [],
          homeMenuList = [{ title: '首页', path: '/index', icon: 'home' }]

          menuList = resolveCurrentMenuList(menuList)

          menuList = [...homeMenuList, ...resolveRouterMenuList(menuList)]
          sessionStorage.setItem('menuStr', JSON.stringify(menuList))

          commit('setSystemUser', systemUser)
          // 设置用户名和头像
          dispatch('d2admin/user/set',{
              avatar: systemUser.avatar,
              name: systemUser.realName,
              systemUserId: systemUser.systemUserId
          },{ root: true })
          // 设置顶栏菜单
          commit('d2admin/menu/headerSet', menuList)
          // 设置侧边栏菜单
          commit('d2admin/menu/asideSet', menuList)
          // 初始化菜单搜索功能
          commit('d2admin/search/init', menuList)
      }
      let LocalStorageSystemUser = LocalStorage.get(LocalStorage.keys.systemUser)
      let LocalStorageUuid = LocalStorage.get(LocalStorage.keys.uuid)
      let uuid = util.cookies.get('uuid')
      // LocalStorageUuid, uuid 判断是否切换了用户，未切换则优先使用本地缓存
      if (LocalStorageSystemUser && LocalStorageUuid === uuid) {
        setData(LocalStorageSystemUser)
        return LocalStorageSystemUser
      }
      let res = await GetCurrentUserInfo({
        serverName: 'oauth-server',
        isReduceField: true
      })
      if (res && res.success && res.data.systemUser) {
        let systemUser = {
          systemUserId: res.data.systemUser.systemUserId,
          realName: res.data.systemUser.realName,
          avatar: res.data.systemUser.avatar,
          jobnumber: res.data.systemUser.jobnumber,
          phone: res.data.systemUser.phone,
          email: res.data.systemUser.email,
          position: res.data.systemUser.position,
          systemMenuPermissionsRoot: res.data.systemUser.systemMenuPermissionsRoot || {},
          systemRoles: res.data.systemUser.systemRoles || []
        } 

        
        setData(systemUser)
        LocalStorage.set(LocalStorage.keys.systemUser, systemUser) // 缓存系统用户信息
        return systemUser
      }
    },
  },
  modules: {
    d2admin
  }
})
